import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import FlatRenewalSuggestionsList from './FlatRenewalSuggestionsList';
import GroupedRenewalSuggestionsList from './GroupedRenewalSuggestionsList';
import './RenewalSuggestionsList.less';

const RenewalSuggestionsList: React.FC = () => {
    const { renewalSuggestionsStore } = useAppStore();

    return (
        <div className="renewal-suggestions-list-container">
            {renewalSuggestionsStore.renewalSuggestionGroupCount > 1 ? (
                <GroupedRenewalSuggestionsList />
            ) : (
                <FlatRenewalSuggestionsList />
            )}
        </div>
    );
};

export default observer(RenewalSuggestionsList);
